import '@babel/polyfill'
import Vue from 'vue'
import App from './App'
import iView from 'iview'
import router from './router'
import api from './api'
import mixins from './mixin/mixins'
import Es6Promise from 'es6-promise'
import Toast from '@/plugins/ShowToast/ShowToast'
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false
Vue.mixin(mixins)
Vue.use(Toast)
Vue.use(iView)
Vue.use(VueAnalytics, {
  id: 'UA-64002767-3',
  router
})
Vue.prototype.$api = api
Es6Promise.polyfill()

// 修复IE10及以下版本不支持dataset属性的问题，兼容transfer-dom.js中使用了dataset的问题
var isIE =
  navigator.userAgent.indexOf('compatible') > -1 &&
  navigator.userAgent.indexOf('MSIE') > -1
if (isIE && window.HTMLElement) {
  if (
    Object.getOwnPropertyNames(HTMLElement.prototype).indexOf('dataset') === -1
  ) {
    Object.defineProperty(HTMLElement.prototype, 'dataset', {
      get: function () {
        let attributes = this.attributes
        let name = []
        let value = []
        let obj = {}
        for (let i = 0; i < attributes.length; i++) {
          if (attributes[i].nodeName.slice(0, 5) === 'data-') {
            name.push(attributes[i].nodeName.slice(5))
            value.push(attributes[i].nodeValue)
          }
        }
        for (let j = 0; j < name.length; j++) {
          obj[name[j]] = value[j]
        }
        return obj
      }
    })
  }
}

var isIE9 = function () {
  return window.navigator.userAgent.indexOf('MSIE 9.0') >= 1
}

// 修复IE9不支持performance.now()，导致tranfer无效，左侧主菜单不显示、poptip错位等问题
if (isIE9() && window.performance) {
  window.performance.now = function () {
    return +new Date() - performance.timing.navigationStart
  }
}

// window.requestAnimationFrame() 兼容ie9
window.requestAnimationFrame =
  window.requestAnimationFrame ||
  function (fn) {
    return setTimeout(fn, 1000 / 60)
  }
window.cancelAnimationFrame = window.cancelAnimationFrame || clearTimeout

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js